// extracted by mini-css-extract-plugin
module.exports = {"h2":"Main_h2__3KHgx","inputs":"Main_inputs__2sbUX","coe":"Main_coe__1LsTe"};